import { EventEmitter } from 'events';
import type { IAppEvents } from '@/typescript/interfaces/IAppEvents';

class TypedEventEmitter<Events> extends EventEmitter {
    private eventTypes: { [K in keyof Events]?: (args: Events[K]) => void } = {};

    emit<K extends keyof Events>(event: string | symbol | K, ...args: Events[K] extends undefined ? [] : [Events[K]]): boolean {
        return super.emit(event as string | symbol, ...args);
    }

    on<K extends keyof Events>(event: string | symbol | K, listener: (args: Events[K]) => void): this {
        this.eventTypes[event as K] = listener;
        return super.on(event as string | symbol, listener);
    }

    once<K extends keyof Events>(event: string | symbol | K, listener: (args: Events[K]) => void): this {
        this.eventTypes[event as K] = listener;
        return super.on(event as string | symbol, listener);
    }
}

const Events = new TypedEventEmitter<IAppEvents>();

export { Events };
